// @module NXTurn.ShoppingExtensions.LoginRegister
define('C3.ShoppingExtensions.LoginRegister.Login.View'
,	[
	'c3_shoppingextensions_loginregister_login.tpl'
	,  'Profile.Model'
	//,	'NXTurn.ShoppingExtensions.LoginRegister.SS2Model'
	,	'Backbone'
	,   'Backbone.FormView'
	,   'Backbone.CompositeView'
	,    'Tracker'
	//,	'SC.Configuration'
    ,   'Session'	
    ,   'C3.ShoppingExtensions.LoginRegister.Login.Model'
    ,   'Utils'
    ,   'LiveOrder.Model'
    ,   'GlobalViews.Message.View'
    ,   'C3.ShoppingExtensions.LoginRegister.ForgotPassword.View'
    ,   'GoogleTagManager'
    ]
, function (
	c3_shoppingextensions_loginregister_login_tpl
	,   ProfileModel
	//,	LoginRegisterSS2Model	
	,	Backbone
	,   BackboneFormView
	,   BackboneCompositeView
	,   Tracker
	//,   Configuration
	,   Session
	,   AccountLoginModel
	,   Utils
	,   LiveOrderModel
	,   GlobalViewsMessageView
    ,   ForgotPasswordView
    ,   GoogleTagManager
)
{
    'use strict';

	// @class NXTurn.ShoppingExtensions.LoginRegister.View @extends Backbone.View
	return Backbone.View.extend({

		template: c3_shoppingextensions_loginregister_login_tpl

	, attributes: {
        id: 'login'
    }	

    ,  events: {
        'submit form': 'submitForm',
        //'click [data-action="register-now"]': 'skipLoginCloseModal',
        'click [data-action="forgot-password"]': 'forgotPasswordHandler',
        'click [data-action="show-hidden-login-section"]':'showHiddenSection'
    }

    ,   bindings: {
        '[name="email"]': 'email',
        '[name="password"]': 'password'
    }

	,	initialize: function (options) {
		this.application = options.application;
		this.configuration = options.configuration;
        this.parentView = options.parentView;
        this.model = new AccountLoginModel();
        this.timedout =
            options.timedout || (typeof window !== 'undefined' && Utils.getParameterByName(window.location.href, 'timeout') === 'T');
        // on save we redirect the user out of the login page as we know there hasn't been an error
        this.model.on('save', _.bind(this.redirect, this));
        BackboneFormView.add(this);
			
		}

      // @method forgotPasswordHandler handles the 'forgot-password' redirection
    , forgotPasswordHandler: function(e) {

           // console.log(e)
            e.stopPropagation();
            e.preventDefault();
            
            var Layout = this.application.getComponent('Layout');
            var view = new ForgotPasswordView(
                        {application: this.application,layout:Layout});

            if (view)
                    Layout.showContent(view, {showInModal: true});
    },  


    showHiddenSection: function(e){
        var $target = $(e.target)
        ,   currentAttr = $target.attr('id');

        /*$('.login-register-wrapper-register .create-account-sec').addClass('hide');
        $('.dont-have-account-sec').removeClass('hide');
        $('.create-account-sec').removeClass('open');
        $('.create-account-sec').css('display','none');

        $('.login-register-wrapper-login .section-body').slideDown(300).removeClass('hide');
        $('.login-register-wrapper-login .login-to-acc-sec').removeClass('open');

        $target.addClass('active');

        $('.login-register-popup .popup-header').css('top','4%')*/
       // $('.create-account-sec').slideDown(600).addClass('open');
        //console.log(currentAttr)
        $('.login-register-popup .popup-header').css('top','4%')

        $('.login-register-wrapper-login .section-body').slideDown(500).addClass('open');
        $('.login-to-acc-sec').removeClass('open');

        $('.dont-have-account-sec').addClass('open');
        $('.login-register-wrapper-register .create-account-sec').slideUp(500).removeClass('open');
    }

	, submitForm: function(e, model, props) {
        e.preventDefault();

        const self = this;
        const data = (jQuery(e.target).closest('form')).serializeObject();

        //adding email,pwd in a localstorage
        if (this.$('input[name=remember]').is(':checked')) {
            localStorage.setItem("remember", data.remember);
            localStorage.setItem("username", data.email);
            localStorage.setItem("password", data.password);
        }else
        {
            localStorage.removeItem("remember");
            localStorage.removeItem("username");
            localStorage.removeItem("password");
        }
        
        /*return this.cancelableTrigger('before:LoginRegister.login', data).then(function() {
            self.saveForm(e, model, props);
        });*/
        const promise = this.saveForm(e, model);
        if (promise) {
            promise
            .fail(function(jqXhr) {
                //console.log(jqXhr)
                var response = jqXhr.responseJSON
                if(response.errorStatusCode === '400'){
                    console.log(response.errorMessage)
                    var $alert_placeholder = self.$el.find('[data-type="login-alert-placeholder"]')
                    const global_view_message = new GlobalViewsMessageView({
                        message: response.errorMessage,
                        type: 'error',
                        closable: false
                    });
                     $alert_placeholder.html(
                        global_view_message.render().$el.html()
                    );
                     this.error = null;
                    //self.$el.find('[data-type="login-alert-placeholder"]').html(response.errorMessage)
                }
            })
            .done(function(res) {
                console.log(res);
            })
        }
    }	

    ,   beforeShowContent: function beforeShowContent() {
        const promise = jQuery.Deferred();
        const profileModel = ProfileModel.getInstance();

        if (profileModel.get('isLoggedIn') === 'T' && profileModel.get('isGuest') === 'F') {
            Backbone.history.navigate('', { trigger: true });

            promise.reject();
        } else {
            promise.resolve();
        }

        return promise;
    }

	,  childViews: {
        GlobalMessageSessionTimeout: function() {
            return new GlobalViewsMessageView({
                message: Utils.translate('Your session has timed out. Please log in again.'),
                type: 'error',
                closable: false
            });
        }
    }

    ,   trackEvent: function(callback) {
        Tracker.getInstance().trackLogin({
            category: 'Checkout - User Interaction',
            action: 'Login',
            callback: callback
        });
    }


    , redirect: function(context, response) {

        //console.log(response)
        
        //Snippet for GTM DataLayer
        var userData = response.user
        ,   loggedUserEmail = userData.email

        const gtm = GoogleTagManager;
        const eventName = 'identifyUser';
         const eventData = {
            event: eventName,
            userEmail: loggedUserEmail
         }
         Tracker.trigger(eventName, eventData);
         gtm.pushData(eventData);
         //console.log(gtm.win);

        /*console.log(loggedUserEmail)
        var _etmc = [];
        _etmc.push(["setUserInfo", {"email": loggedUserEmail }]);
        _etmc.push(['trackPageView']);*/
             
        // Track Login Event
        this.trackEvent(function() {            
            setTimeout(function(){
                location.reload(true);
            }, 1000);
           // console.log(user.email);
        });
    }


		//@method getContext @return NXTurn.ShoppingExtensions.LoginRegister.View.Context
	,	getContext: function getContext()
		{
			const url_options = typeof window !== 'undefined' ? Utils.parseUrlOptions(window.location.search) : {};
			return {

                rememberMe : typeof localStorage !== 'undefined' && localStorage.getItem('remember') ? true : false,
                rememberEmail : typeof localStorage !== 'undefined' && localStorage.getItem('username') || '',
                rememberPass : typeof localStorage !== 'undefined' && localStorage.getItem('password') || '',
				// @property {Boolean} isRedirect
	            isRedirect: !!(url_options.is !== 'checkout' && url_options.origin !== 'checkout'),
	            // @property {Boolean} hasAutoFocus
	            hasAutoFocus: url_options.is !== 'register' && Utils.isDesktopDevice(),
	            // @property {Boolean} isUserSessionTimedOut
	            isUserSessionTimedOut: url_options.timedout === 'T' || this.timedout,
	            // @property {Boolean} isSkipLogin
	            isSkipLogin: !!(
	                this.$containerModal && this.application.getConfig('checkoutApp.skipLogin')
	            )
			};
		}
	});
});
